import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'



import { 
    displayModalAddAsistencia,
    updateInputs,
    editAsistencia
} from '../../actions/tiquetesaereo'

class ModalAddAsistencia extends Component {

	handleCloseModal = (e) => {
		const modal = document.getElementById('modalAddAsistencia')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalAddAsistencia .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.displayModalAddAsistencia(false, '', ''), 300)
    }
    


	render() {

        const { modalAddAsistencia } = this.props

		if (!modalAddAsistencia.get('show')) {
			return null
        }


		return(
			<Modal id="modalAddAsistencia" show={ true } ZIndex={ 2000 } width={ 820 } >
				<form id="form" onSubmit={ e => { e.preventDefault(); this.props.editAsistencia(modalAddAsistencia.get('index')) }} noValidate>
					<ModalHeader title={ modalAddAsistencia.get('title') } onClose={ (e) => this.handleCloseModal(e) } />
					<ModalButtonStrip>
                        <BoxButton name="check" disabled={ modalAddAsistencia.get('btnDisabled') } title="Aceptar" />
					</ModalButtonStrip>
					<ModalBody>
                        <Fragment>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="control-label">Proveedor</label>
                                        <input className="form-control input-sm" value={ modalAddAsistencia.getIn(['data', 'asistencia', 'proveedor']) ||'' } disabled />
                                    </div>
                                </div>
                            </div>

                            <div className="separator"></div>

                            <div className="row">
                                <div className="col-md-12">
                                    <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-trayectos">
                                        <thead>
                                            <tr>
                                                <th>País destino</th>
                                                <th>Fecha salida</th>
                                                <th>Fecha regreso</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{ modalAddAsistencia.getIn(['data', 'asistencia', 'pais_destino']) }</td>
                                                <td>{ moment(modalAddAsistencia.getIn(['data', 'asistencia', 'fecha_salida'])).format('DD/MM/YYYY') }</td>
                                                <td>{ moment(modalAddAsistencia.getIn(['data', 'asistencia', 'fecha_regreso'])).format('DD/MM/YYYY') }</td>
                                            </tr>
                                        </tbody>                                                
                                    </table>
                                </div>                            
                            </div>

                            <div className="separator"></div>

                            <div className="row">

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">Número voucher</label>
                                        <input className="form-control input-sm" value={ modalAddAsistencia.getIn(['data', 'asistencia', 'numero_voucher']) || '' } onChange={ (e) => this.props.updateInputs(`modalAddAsistencia.data.asistencia.numero_voucher`, e.target.value) } />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">
                                            Voucher
                                        </label>
                                        <label className={`form-control input-sm label-upload-file label-upload-file-enabled`} onClick={ () => this.props.displayModalAddFile(true, 'Adjuntar archivo', 'create')} >
                                            <i className="fa fa-upload"></i> 
                                            {
                                                modalAddAsistencia.getIn(['data', 'asistencia', 'adjunto', 'id']) ? (
                                                    <Fragment>                                                        
                                                        { modalAddAsistencia.getIn(['data','asistencia','adjunto']) ? modalAddAsistencia.getIn(['data','asistencia','adjunto', 'nombre']) : ' Seleccione un archivo...' }
                                                    </Fragment>
                                                ) : (
                                                    <Fragment>
                                                        { modalAddAsistencia.getIn(['data','asistencia','adjunto']) ? modalAddAsistencia.getIn(['data','asistencia','adjunto', 'file']).name : ' Seleccione un archivo...' }
                                                    </Fragment>
                                                )
                                            }
                                        </label>
                                    </div>
                                </div>

                            </div>


                            <div className="row">

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">Fecha de compra</label>
                                        <input className="form-control input-sm" type="date" value={ modalAddAsistencia.getIn(['data', 'asistencia', 'fecha_compra']) || '' } onChange={ (e) => this.props.updateInputs(`modalAddAsistencia.data.asistencia.fecha_compra`, e.target.value) } />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">Valor</label>
                                        <input className="form-control input-sm" value={ modalAddAsistencia.getIn(['data', 'asistencia', 'valor']) || '' } onChange={ (e) => this.props.updateInputs(`modalAddAsistencia.data.asistencia.valor`, e.target.value) } />
                                    </div>
                                </div>                            
                            
                            </div>
                            
                        </Fragment>
					</ModalBody >
					<ModalFooter >
					</ModalFooter>
				</form>
			</Modal>
		)
	}
}

const mapStateToProps = (state) => {
	return {
        modalAddAsistencia: state.tiquetesaereo.get('modalAddAsistencia'),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
        displayModalAddAsistencia: (show, title, mode) => dispatch(displayModalAddAsistencia(show, title, mode)), 
        updateInputs: (path, value) => dispatch(updateInputs(path, value)), 
        editAsistencia: (index) => dispatch(editAsistencia(index)), 
	}
}




export default connect(mapStateToProps, mapDispatchToProps)(ModalAddAsistencia)



// WEBPACK FOOTER //
// ./src/components/TiquetesAereos/ModalAddAsistencia.jsx